<template>
  <div class="panel cc-panel">
    <p class="panel-heading">
      {{ $t("i18n.chartTitles.ccDistribution") }}
    </p>
    <div class="panel-block">
      <div :id="this.idChartDiv" class="cc-chart" :style="chartDivInlineStyle"></div>
    </div>
  </div>
</template>
<script>
import * as am5 from '@amcharts/amcharts5'
import * as am5percent from '@amcharts/amcharts5/percent'
import * as am5exporting from '@amcharts/amcharts5/plugins/exporting'
import ccColors from '@/components/ccColors'

export default {
  name: 'ccDistribution',
  props: {
    idChartDiv: {
      type: String,
      required: true
    },
    totals: {
      type: Object,
      required: true
    },
    chartDivInlineStyle: {
      type: String,
      required: true
    }
  },
  computed: {
    compPercentage: function () {
      const compPercentage = (100 * this.totals.compressor) / (this.totals.compressor + this.totals.auxiliary)
      return Math.round(compPercentage)
    },
    auxPercentage: function () {
      const auxPercentage = (100 * this.totals.auxiliary) / (this.totals.compressor + this.totals.auxiliary)
      return Math.round(auxPercentage)
    }
  },
  data () {
    return {}
  },
  mounted () {
    this.buildChart()
  },
  methods: {
    buildChart: function () {
      am5.addLicense(this.$store.state.am5)
      const root = am5.Root.new(this.idChartDiv)

      const data = [{
        value: this.compPercentage,
        category: this.$t('i18n.global.compressor'),
        color: ccColors.energyComp
      }, {
        value: this.auxPercentage,
        category: this.$t('i18n.global.auxiliary'),
        color: ccColors.energyAux
      }]

      // Create chart
      const chart = root.container.children.push(am5percent.PieChart.new(root, {
        layout: root.horizontalLayout,
        paddingTop: 0
      }))

      // Create series
      const series = chart.series.push(am5percent.PieSeries.new(root, {
        valueField: 'value',
        categoryField: 'category',
        fillField: 'color',
        legendValueText: '{value}%'
      }))

      series.slices.template.setAll({
        stroke: 0
      })

      series.labels.template.setAll({
        templateField: 'sliceSettings'
      })

      // Set data
      series.data.setAll(data)

      // Disable pulling out
      series.slices.template.set('toggleKey', 'none')
      series.slices.template.states.create('active', {
        shiftRadius: 0,
        strokeWidth: 0
      })
      series.slices.template.states.create('hover', {
        scale: 1
      })

      // Disable hoover/tooltip
      series.slices.template.set('tooltipText', '')

      // Create legend
      const legend = chart.children.push(am5.Legend.new(root, {
        centerY: am5.percent(50),
        y: am5.percent(50),
        fillField: 'color',
        strokeField: 'color',
        clickTarget: 'none', // Disable clickable legends
        layout: root.verticalLayout
      }))

      legend.data.setAll(series.dataItems)

      // Remove labels and ticks on slices
      series.ticks.template.setAll({
        visible: false
      })
      series.labels.template.setAll({
        visible: false
      })

      // Add export menu
      am5exporting.Exporting.new(root, {
        menu: am5exporting.ExportingMenu.new(root, {})
      })

      // Play initial series animation
      series.appear(1000, 100)
    }
  }
}
</script>
